import React, { useState, useLayoutEffect, useRef } from 'react'
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};
  align-items: ${({ middle }) => (middle ? 'center' : 'flex-start')};
  min-height: 70vw;
  margin: 0;
  padding: 50px;
  ${({ image }) =>
    image &&
    css`
      background: center center url(${image}) no-repeat;
      background-size: cover;
    `}
  background-color: ${({ theme, color, image }) =>
    !image ? theme.colors[color] : theme.colors.darkSecond};

  ::after {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 0;
    background: ${({ theme, color, image }) =>
      image
        ? theme.colors[color]
        : color === 'primary'
        ? theme.colors.darkSecond
        : theme.colors.primary};
    transition: height .9s ease;
    content: '';
  }

  :last-child:after {
    transition-delay: 0.3s;
  }

  ${({ theme }) => theme.media.m} {
    padding: 50px 100px;

    p {
      max-width: 480px;
    }

    ::after {
    height: ${({ isVisible }) => (isVisible ? '0' : '100%')};
  }
  }

  ${({ theme }) => theme.media.l} {
    min-height: 0;
    padding: 30px;
  }
`

const ContentBox = ({ image, color, center, middle, children }) => {
  const [elementVisible, setElementVisible] = useState(false)
  const inputEl = useRef(null)
  
  useLayoutEffect(() => {
    let topPosition = inputEl.current.getBoundingClientRect().top - 400

    typeof window !== 'undefined' &&
      window.addEventListener('scroll', function() {
        if (window.pageYOffset > topPosition) {
          setElementVisible(true)
        }
      })
  })

  return (
    <Wrapper
      image={image}
      color={color}
      center={center}
      middle={middle}
      ref={inputEl}
      isVisible={elementVisible}
    >
      {children}
    </Wrapper>
  )
}

export default ContentBox
